export const iconFontAwesomeFilesFileLines = (
	<i className="fa-solid fa-file-lines"></i>
);
